import React from "react";
import { ArrowRight } from "react-feather";
import { useNavigate } from "react-router-dom";
import "./Landing.css";

const HERO = {
  src: "/slider.png",
  alt: "Personalised Tata Motors comfort kit headrest"
};

const LandingPage = () => {
  const navigate = useNavigate();

  return (
    <div className="tm-landing">
      <header className="tm-header">
        <a className="tm-header__brand" href="/" aria-label="Tata Motors home">
          <img
            src="/brand/tata-logo.png"
            alt="Tata Motors"
            className="tm-header__logo"
          />
        </a>
        <span className="tm-header__eyebrow">Personalisation</span>
      </header>

      <section className="tm-hero">
        <img className="tm-hero__media" src={HERO.src} alt={HERO.alt} />
        <div className="tm-hero__scrim" aria-hidden="true" />

        <button
          type="button"
          className="tm-btn tm-btn--glass tm-hero__cta"
          onClick={() => navigate("/personalise")}
        >
          <span>Go personalise</span>
          <ArrowRight size={20} aria-hidden="true" />
        </button>
      </section>
    </div>
  );
};

export default LandingPage;
